import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Adjustment } from '@ztechapps/common.contract'
import { useAdjustmentIdParam } from './useAdjustmentIdParam'
import { adjustmentDocumentQueries } from './graphql'

export const useAdjustmentDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const adjustmentId = useAdjustmentIdParam()

  const defaultQuery = query ?? adjustmentDocumentQueries.singleConfig.query

  return useDocument<Adjustment>({ query: defaultQuery, _id: adjustmentId, ...props })
}
